export default __webpack_public_path__ + "static/media/lima.166b3c05.png";